// Helpers puros del estado de vacunas y desparasitación de la 360 (GET /pets/360/health-status).
// El backend calcula el estado con las mismas reglas del carnet de salud de la app; aquí solo
// se traduce a textos y colores. No llaman servicios ni tocan el DOM.

export const HEALTH_STATUS_DISPLAY = {
  overdue: { text: 'Atrasada', color: 'error', icon: 'mdi-alert-circle' },
  dueSoon: { text: 'Por vencer', color: 'warning', icon: 'mdi-clock-alert-outline' },
  upToDate: { text: 'Al día', color: 'success', icon: 'mdi-check-circle-outline' },
  noRecords: { text: 'Sin registro', color: 'grey', icon: 'mdi-minus-circle-outline' }
};

// Estado desconocido (p. ej. uno nuevo del backend) se muestra como «Sin registro».
export function healthStatusDisplay(status) {
  return HEALTH_STATUS_DISPLAY[status] || HEALTH_STATUS_DISPLAY.noRecords;
}

// 'YYYY-MM-DD' → 'DD/MM/AAAA'; sin fecha → '—'. Sin Date para no correr el día por zona horaria.
export function formatHealthDate(day) {
  if (!day) return '—';
  const [year, month, date] = day.split('-');
  return `${date}/${month}/${year}`;
}

// Estado de una mascota dentro de la respuesta, o null si no viene.
export function petHealthOf(petHealth, petId) {
  if (!petHealth || !Array.isArray(petHealth.pets)) return null;
  return petHealth.pets.find(pet => pet.petId === petId) || null;
}

// Qué está atrasado: 'Vacunas y desparasitación' | 'Vacunas' | 'Desparasitación' | null.
// Sirve tanto para el tutor (flags globales) como para una mascota (mismos nombres de flags).
export function overdueSummary(status) {
  if (!status) return null;
  const { hasOverdueVaccines, hasOverdueDeworming } = status;
  if (hasOverdueVaccines && hasOverdueDeworming) return 'Vacunas y desparasitación';
  if (hasOverdueVaccines) return 'Vacunas';
  if (hasOverdueDeworming) return 'Desparasitación';
  return null;
}
